var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.466 0H1.86602C1.20602 0 0.672016 0.54 0.672016 1.2L0.666016 12L3.06602 9.6H11.466C12.126 9.6 12.666 9.06 12.666 8.4V1.2C12.666 0.54 12.126 0 11.466 0ZM9.66602 7.2H3.66602C3.33602 7.2 3.06602 6.93 3.06602 6.6C3.06602 6.27 3.33602 6 3.66602 6H9.66602C9.99602 6 10.266 6.27 10.266 6.6C10.266 6.93 9.99602 7.2 9.66602 7.2ZM9.66602 5.4H3.66602C3.33602 5.4 3.06602 5.13 3.06602 4.8C3.06602 4.47 3.33602 4.2 3.66602 4.2H9.66602C9.99602 4.2 10.266 4.47 10.266 4.8C10.266 5.13 9.99602 5.4 9.66602 5.4ZM9.66602 3.6H3.66602C3.33602 3.6 3.06602 3.33 3.06602 3C3.06602 2.67 3.33602 2.4 3.66602 2.4H9.66602C9.99602 2.4 10.266 2.67 10.266 3C10.266 3.33 9.99602 3.6 9.66602 3.6Z",
    fill: "#060606"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.b83633ae3fa283978f5ae28e39132b79.svg";
export { ForwardRef as ReactComponent };